import {
  capitalize,
  IconButton,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PATH_DASHBOARD } from "../../../routes/paths";
import { ITill } from "../../../@types/till";
import MenuPopover from "../../../components/menu-popover";
import Iconify from "../../../components/iconify";
import { useState } from "react";

type Props = {
  till: any; //todo: change ITill to respective type
};

export default function TillTableRow({ till }: Props) {
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const handleViewTill = () => {
    navigate(PATH_DASHBOARD.till.detail(till.id), {
      state: { patientData: till },
    });
  };

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <TableRow hover>
        <TableCell
          style={{ cursor: "pointer" }}
          align="center"
          onClick={handleViewTill}>
          <Typography variant="subtitle2" noWrap>
            {till.patient.firstName} {till.patient.lastName}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography
            variant="subtitle2"
            style={{ cursor: "pointer" }}
            noWrap
            onClick={handleViewTill}>
            {till.id}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle2" noWrap>
            {till?.dispenseTills?.length ? till?.dispenseTills?.length : 0}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle2" noWrap>
            {till.date?.toLocaleDateString()}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle2" noWrap>
            {till?.dispenseTills
              ? capitalize(till?.dispenseTills[0]?.status)
              : "N/A"}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <IconButton
            color={openPopover ? "inherit" : "default"}
            onClick={handleOpenPopover}>
            <Iconify icon="eva:more-horizontal-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        arrow="right-top"
        sx={{ width: 160 }}>
        <MenuItem
          onClick={() => {
            handleViewTill();
            handleClosePopover();
          }}>
          <Iconify icon="eva:eye-fill" />
          View
        </MenuItem>
      </MenuPopover>
    </>
  );
}
